import TheGrid from '@/views/scorecard/independents/results/grid'

export default {
  path: '/scorecard-independents/results',
  redirect: '/scorecard-independents/results/index',
  name: 'scIndependentsResults',
  meta: {
    auth: {
      redirect: {
        name: 'scIndependentsResults.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Scorecard'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'scIndependentsResults.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Resultados'
    }
  }]
}
